import React from "react";
import Context from "../../../Context";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import Blocker from "../../Misc/Blocker";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import Select from "react-select";
import SuperSelect from "../../Misc/SuperSelect";
import FormLine from "../../Misc/FormLine";
import EssenceReference from "../../Essence/EssenceReference";
import EssenceReferenceCisternEdit from "../../Essence/EssenceReferenceCisternEdit";
import ElementPicker from "../../Misc/ElementPicker";
import MaintPicker from "../../Misc/MaintPicker";
import ProductPicker from "../../Misc/ProductPicker";
import ElasticInput from "../../Misc/ElasticInput";
import ModelPicker from "../../Misc/ModelPicker";

export default class ActMaintenance extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      item: {},
      lines: [],
      prodlines: [],

      measure: [],
      elements: {},
      maintenance: {},
      models: {},

      elementPickIdx: false,
      elementPickShow: false,
      maintPickIdx: false,
      maintPickShow: false,

      mode: "element",
    };
  }

  componentDidMount() {
    this.loadReferences().then(() => this.load());
    this.renderButtons();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.docId !== this.props.docId) {
      this.load();
    }
    this.renderButtons();
  }

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };

  onLineChange = (idx, key, value) => {
    let { lines } = this.state;
    lines[idx][key] = value;
    this.setState({ lines });
  };

  onProdLineChange = (idx, key, value) => {
    let { prodlines } = this.state;
    prodlines[idx][key] = value;
    this.setState({ prodlines });
  };

  onModelPickOpen = (idx) => {
    this.setState({ modelPickShow: true, modelPickIdx: idx });
  };

  onModelPickClose = () => {
    this.setState({ modelPickShow: false });
  };

  onCreateModel = async (model) => {
    this.setState(
      (state) => {
        let { models } = state;
        models[model.id] = { label: model.label };
        return { models };
      },
      () => this.onProdLineChange(this.state.modelPickIdx, "modelid", model.id)
    );
  };

  getModelLabel = (id, defaultLabel = "") => {
    let result = defaultLabel;
    if (this.state.models[id]) {
      result = `${this.state.models[id].label}`;
    }
    return result || "";
  };

  onModelPick = (model) => {
    this.setState(
      ({ models }) => {
        models[model.id] = model;
        return models;
      },
      () => this.onProdLineChange(this.state.modelPickIdx, "modelid", model.id)
    );
  };

  loadReferences = async () => {
    this.setState({ pending: true });
    let measure = await this.context.api.qr("/measure/list");
    let elements = await this.context.api.qo("/element/list", { reclimit: 0 });
    let maintenance = await this.context.api.qo("/maintenance/list");
    this.setState({ pending: false, measure, elements, maintenance });
  };

  rowAdd = (idx) => {
    let { lines } = this.state;
    let index = idx || lines.length;
    lines.splice(index, 0, {});
    this.setState({ lines });
  };

  rowProdAdd = (idx) => {
    let { prodlines } = this.state;
    let index = idx || prodlines.length;
    prodlines.splice(index, 0, {});
    this.setState({ prodlines });
  };

  rowRemove = (idx) => {
    let { lines } = this.state;
    lines.splice(idx, 1);
    this.setState({ lines });
  };

  rowProdRemove = (idx) => {
    let { prodlines } = this.state;
    prodlines.splice(idx, 1);
    this.setState({ prodlines });
  };

  load = async () => {
    const { docId } = this.props;
    this.setState({ pending: true, notFound: false });
    if (docId && docId !== "add") {
      let item = await this.context.api.q("/act/get", { id: docId });
      if (!item) {
        this.setState({ notFound: true });
      } else {
        let lines = await this.context.api.qa("/act/maintenance/list", {
          filter: { documentid: docId },
          orderby: ["itemid ASC"],
        });
        let prodlines = await this.context.api.qa(
          "/act/maintenance/item/list",
          {
            filter: { documentid: docId },
            orderby: ["itemid ASC"],
          }
        );

        this.setState({ item, lines: lines || [], prodlines: prodlines || [] });
      }
    } else {
      let item = {};
      let lines = [];
      let prodlines = [];

      let searchParams = new URLSearchParams(
        this.props.location.search.substr(1)
      );

      let append = searchParams.get("append");
      if (append) {
        let appendItems = append.split(",");
        appendItems.forEach((id) => {
          lines.push({ cisternid: id });
        });
      }

      let maint = searchParams.get("maint");
      let element = searchParams.get("element");
      if (maint && element) {
        lines.push({
          elementid: element,
          maintenanceid: maint,
        });

        let requirements = await this.context.api.qa(
          "/maintenance/requirement/list",
          {
            filter: {
                maintenanceitemid: maint,
            },
            orderby: ["sequence"],
          }
        );
        requirements.forEach((reqItem) => {
          prodlines.push({
            modelid: reqItem.modelid,
            model: reqItem.model,
            volume: reqItem.volume,
            measureid: reqItem.measureid,
          });
        });
      }

      let ship = searchParams.get("ship");
      if (ship) {
        item.ship = ship;
      }

      this.setState({ item, lines, prodlines });
    }
    this.setState({ pending: false });
    this.context.force();
  };

  save = async () => {
    let docId = null;
    if (this.props.docId && this.props.docId !== "add") {
      docId = this.props.docId;
    }

    const { item } = this.state;
    this.setState({ pending: true });
    let saveData = {
      id: docId,
      description: item.description,
      ship: item.ship,
    };
    let result = await this.context.api.q("/act/set", saveData);

    if (result !== false) {
      let items = [];
      let { lines } = this.state;
      lines.forEach((line) => {
        items.push({
          elementid: line.elementid,
          description: line.description,
          maintenanceid: line.maintenanceid,
          metervalue: line.metervalue,
        });
      });

      let itemsResult = await this.context.api.q("/act/maintenance", {
        items,
        document: result.id,
      });

      let products = [];
      let { prodlines } = this.state;
      prodlines.forEach((line) => {
        products.push({
          modelid: line.modelid,
          measureid: line.measureid,
          volume: line.volume,
          description: line.description,
        });
      });

      let productsResult = await this.context.api.q("/act/maintenance/item", {
        items: products,
        document: result.id,
      });

      if (itemsResult !== false && productsResult !== false) {
        this.context.toast("Изменения сохранены", "success");
      } else {
        this.context.toast("Не удалось сохранить изменения", "error");
      }

      if (this.props.docId === "add") {
        this.setState({ pending: false });
        this.context.redirect(`/act_maintenance/${result.id}`);
      } else {
        this.load();
      }
    } else {
      this.setState({ pending: false });
      this.context.toast("Не удалось сохранить изменения", "error");
    }
  };

  new = () => {
    this.setState({ lines: [] });
    this.context.redirect("/act_maintenance/add");
  };

  open = () => {
    const { docId } = this.props;
    if (docId && docId !== "add") {
      this.context.redirect(`/workdoc/any/any/${docId}`);
    } else {
      this.context.redirect("/workdoc/");
    }
  };

  renderButtons = () => {
    this.context.actionsSet(
      <>
        <button
          title="Новый"
          onClick={this.new}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-file-o"></i>
        </button>
        <button
          title="Сохранить"
          onClick={this.save}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-save"></i>
        </button>
        <button
          title="Открыть"
          onClick={this.open}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-folder-open-o"></i>
        </button>
      </>
    );
  };

  onElementPickOpen = (idx) => {
    this.setState({ elementPickShow: true, elementPickIdx: idx });
  };

  onMaintPickOpen = (idx) => {
    this.setState({ maintPickShow: true, maintPickIdx: idx });
  };

  onElementPickClose = () => {
    this.setState({ elementPickShow: false });
  };

  onMaintPickClose = () => {
    this.setState({ maintPickShow: false });
  };

  onElementPick = (elem) => {
    this.onLineChange(this.state.elementPickIdx, "elementid", elem.id);
  };

  onMaintPick = (maint) => {
    this.onLineChange(this.state.maintPickIdx, "maintenanceid", maint.id);
  };

  getElementLabel = (id) => {
    const { elements } = this.state;
    if (elements[id]) {
      return `${elements[id].label} ${elements[id].modelname}` || "";
    }
    return "";
  };

  getMaintLabel = (id) => {
    const { maintenance } = this.state;
    if (maintenance[id]) {
      return `${maintenance[id].label}` || "";
    }
    return "";
  };

  onModeChange = (mode) => {
    this.setState({ mode });
  };

  render() {
    const { item, notFound, pending, lines, prodlines } = this.state;
    const { docId } = this.props;
    let title = docId === "add" ? "Новый Акт выполнения ТО" : item.label;

    if (notFound) {
      title = "Документ не найден";
      return (
        <div className="container">
          <CrumbsProvider title={title} link="/act_maintenance/" />
          <DefaultNotFound />
        </div>
      );
    }

    return (
      <>
        <ElementPicker
          onElementPick={this.onElementPick}
          onClose={this.onElementPickClose}
          show={this.state.elementPickShow}
          shipId={item.ship}
        />
        <MaintPicker
          onPick={this.onMaintPick}
          onClose={this.onMaintPickClose}
          show={this.state.maintPickShow}
          shipId={item.ship}
        />
        <ModelPicker
          listKey={this.state.modelPickKey}
          onModelPick={this.onModelPick}
          onClose={this.onModelPickClose}
          onCreate={this.onCreateModel}
          show={this.state.modelPickShow}
          allowCreate
          keepModal
        />
        <CrumbsProvider title={title} link={`/act_maintenance/${item.id}/`} />
        <div className="container h-100">
          <div className="row  h-100">
            <div className="col">
              <div className="card card-custom card-stretch">
                <Blocker on={pending}>
                  <div className="card-body px-5 py-5">
                    <div className="dochat">
                      <div className="flex-grow-1">
                        <div className="row">
                          <div className="col-6">
                            <FormLine label="Судно:">
                              <SuperSelect
                                defaultValue={item.ship}
                                onChange={(value) =>
                                  this.onChange("ship", value)
                                }
                                onSingleItem={(item) =>
                                  this.onChange("ship", item.value)
                                }
                                essence="ship"
                                placeholder="Выберите..."
                                nameField="name"
                                idField="id"
                              />
                            </FormLine>
                          </div>

                          <div className="col-6">
                            <FormLine label="Комментарий:">
                              <input
                                type="text"
                                value={item.description || ""}
                                onChange={(e) =>
                                  this.onChange("description", e.target.value)
                                }
                                className="form-control"
                              />
                            </FormLine>
                          </div>
                        </div>
                      </div>

                      {item.id && (
                        <div className="d-flex align-items-center ml-3">
                          <EssenceStateLabel
                            id={item.id}
                            stateCode={item.statetypecode}
                            stateLabel={item.statelabel}
                            essence="act"
                            onAfterStateChanged={(c) => {
                              if (c === "enabled") {
                                this.open();
                              }
                            }}
                          />
                          <EssenceActionsDropdown
                            essence={"act"}
                            key={item.id}
                            id={item.id}
                            label={item.label}
                            onFinish={this.load}
                          />
                        </div>
                      )}
                    </div>

                    <ul className="nav nav-tabs mb-4">
                      <li className="nav-item w-lg-auto w-100">
                        <div
                          onClick={() => this.onModeChange("element")}
                          className={` ${
                            this.state.mode === "element" ? "active" : ""
                          } cursor-pointer nav-link`}
                        >
                          Оборудование и ТО
                        </div>
                      </li>
                      <li className="nav-item w-lg-auto w-100">
                        <div
                          onClick={() => this.onModeChange("product")}
                          className={` ${
                            this.state.mode === "product" ? "active" : ""
                          } cursor-pointer nav-link`}
                        >
                          Использованные запасы
                        </div>
                      </li>
                    </ul>

                    {this.state.mode === "element" && (
                      <table className="table">
                        <thead>
                          <tr>
                            <th width="45%">
                              <i
                                title="Добавить строку"
                                onClick={() => this.rowAdd()}
                                className="fa fa-plus cursor-pointer text-hover-primary mr-2"
                              ></i>
                              Оборудование
                            </th>
                            <th>Нараб.</th>
                            <th width="45%">ТО</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lines.map((item, idx) => {
                            let line = item || {};
                            return (
                              <React.Fragment key={idx}>
                                <tr>
                                  <td>
                                    <div className="input-group">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={this.getElementLabel(
                                          line.elementid
                                        )}
                                        onDoubleClick={() =>
                                          this.onElementPickOpen(idx)
                                        }
                                        readOnly
                                      />
                                      <div className="input-group-append">
                                        <button
                                          title="Выбрать"
                                          className="btn btn-icon border"
                                          type="button"
                                          onClick={() =>
                                            this.onElementPickOpen(idx)
                                          }
                                        >
                                          <i className="fa icon-md text-muted fa-navicon"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <input
                                      className="form-control"
                                      value={item.metervalue || ""}
                                      size={3}
                                      type="number"
                                      onChange={(e) =>
                                        this.onLineChange(
                                          idx,
                                          "metervalue",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </td>
                                  <td>
                                    <div className="input-group">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={this.getMaintLabel(
                                          line.maintenanceid
                                        )}
                                        onDoubleClick={() =>
                                          this.onMaintPickOpen(idx)
                                        }
                                        readOnly
                                      />
                                      <div className="input-group-append">
                                        <button
                                          title="Выбрать"
                                          className="btn btn-icon border"
                                          type="button"
                                          onClick={() =>
                                            this.onMaintPickOpen(idx)
                                          }
                                        >
                                          <i className="fa icon-md text-muted fa-navicon"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr className="bottom-line">
                                  <td colSpan={15}>
                                    <div className="d-flex align-items-start">
                                      <div className="flex-grow-1">
                                        <ElasticInput
                                          rows={1}
                                          value={line.description || ""}
                                          onChange={(e) =>
                                            this.onLineChange(
                                              idx,
                                              "description",
                                              e.target.value
                                            )
                                          }
                                          className="form-control"
                                          placeholder="Комментрий..."
                                        />
                                      </div>
                                      <div className="ml-3 text-nowrap pt-3">
                                        <i
                                          title="Удалить строку"
                                          onClick={() => this.rowRemove(idx)}
                                          className="fa fa-times cursor-pointer text-hover-danger "
                                        ></i>
                                        <i
                                          title="Добавить строку ниже"
                                          onClick={() => this.rowAdd(idx + 1)}
                                          className="fa fa-plus cursor-pointer text-hover-primary ml-2"
                                        ></i>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                    )}

                    {this.state.mode === "product" && (
                      <table className="table">
                        <thead>
                          <tr>
                            <th width="70%">
                              <i
                                title="Добавить строку"
                                onClick={() => this.rowProdAdd()}
                                className="fa fa-plus cursor-pointer text-hover-primary mr-2"
                              ></i>
                              Наименование
                            </th>
                            <th width="15%">Кол-во</th>
                            <th width="15%">Изм.</th>
                          </tr>
                        </thead>
                        <tbody>
                          {prodlines.map((item, idx) => {
                            let line = item || {};
                            return (
                              <React.Fragment key={idx}>
                                <tr>
                                  <td>
                                    <div className="input-group">
                                      <input
                                        readOnly
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        value={this.getModelLabel(
                                          line.modelid,
                                          line?.model?.name
                                        )}
                                        onDoubleClick={() =>
                                          this.onModelPickOpen(idx)
                                        }
                                      />
                                      <div className="input-group-append">
                                        <button
                                          title="Выбрать"
                                          className="btn btn-icon border"
                                          type="button"
                                          onClick={() =>
                                            this.onModelPickOpen(idx)
                                          }
                                        >
                                          <i className="fa icon-md text-muted fa-navicon"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <input
                                      className="form-control"
                                      value={item.volume || ""}
                                      size={3}
                                      type="number"
                                      onChange={(e) =>
                                        this.onProdLineChange(
                                          idx,
                                          "volume",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </td>
                                  <td>
                                    <Select
                                      value={this.context.api.getReferenceValue(
                                        line.measureid,
                                        this.state.measure
                                      )}
                                      onChange={(result) =>
                                        this.onProdLineChange(
                                          idx,
                                          "measureid",
                                          result.value
                                        )
                                      }
                                      className="from-control react-select"
                                      classNamePrefix="react-select-inner"
                                      options={this.state.measure}
                                      placeholder="..."
                                      noOptionsMessage={({ inputValue }) =>
                                        `Ничего не найдено по запросу ${inputValue}`
                                      }
                                    />
                                  </td>
                                </tr>
                                <tr className="bottom-line">
                                  <td colSpan={15}>
                                    <div className="d-flex align-items-center">
                                      <div className="flex-grow-1">
                                        <ElasticInput
                                          rows={1}
                                          value={line.description || ""}
                                          onChange={(e) =>
                                            this.onProdLineChange(
                                              idx,
                                              "description",
                                              e.target.value
                                            )
                                          }
                                          className="form-control"
                                          placeholder="Комментрий..."
                                        />
                                      </div>
                                      <div className="ml-3 text-nowrap">
                                        <i
                                          title="Удалить строку"
                                          onClick={() =>
                                            this.rowProdRemove(idx)
                                          }
                                          className="fa fa-times cursor-pointer text-hover-danger "
                                        ></i>
                                        <i
                                          title="Добавить строку ниже"
                                          onClick={() =>
                                            this.rowProdAdd(idx + 1)
                                          }
                                          className="fa fa-plus cursor-pointer text-hover-primary ml-2"
                                        ></i>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                    )}
                  </div>
                </Blocker>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
